import React from 'react';
import { useChatbotInitialMessage } from '../../hooks';
import { useCurrentScreen } from '../../hooks/useCurrentScreen';
import { OnuScreens } from '../../types';
import BotChatMessage from './BotChatMessage';
import ChatbotLinks from './ChatbotLinks';
import ChatbotWithSession from './ChatbotWithSession';
import { ResizableGPTContainer } from './ResizableGPT.styles';
import { UserChatMessage } from './UserChatMessage';
import config from './config';
const ResizableGPT = () => {
    const screen = useCurrentScreen() ?? OnuScreens.DASHBOARD;
    const initialMessage = useChatbotInitialMessage(screen);
    return (React.createElement(ResizableGPTContainer, null,
        React.createElement(ChatbotWithSession, { config: config(initialMessage, screen, {
                header: () => React.createElement(React.Fragment, null),
                botAvatar: () => React.createElement(React.Fragment, null),
                userAvatar: () => React.createElement(React.Fragment, null),
                botChatMessage: BotChatMessage,
                userChatMessage: UserChatMessage,
            }) }),
        React.createElement(ChatbotLinks, null)));
};
export default ResizableGPT;
